import { runInAction, makeAutoObservable } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants";

import { ErrorWrapper } from "../utils/ErrorWrapper";
import General from "./GeneralStore";
import User from '../../src/stores/UserStore'
import axios, { AxiosRequestConfig } from "axios";
import { makePersistable } from "mobx-persist-store";
import { NotifyError } from "../../src/utils/ShowError";
import { IValidatePassword, IValidatePasswordForRegistration } from "src/interfaces/IValidatePassword";
interface Obj {
  [key: string]: any;
}

export type MoveOutData = {
  token: string;
  transactionId: string;
  amount: Number;
  paymentRequestType: Number;
  cvv: string;
  type: string;
  sewerageId: string;
  serviceTerminationDate: string;
  isNOCSelected: boolean;
  accountId: string;
  estimatedBillId: string;
  customerAddress: Obj;
};

export type RegistrationData = {
  type: string | null;
  id: string | null;
  personId: string | null;
  uuid?: string | null;
  isUAEPASSEnabled?: boolean | null;
  emiratesId?: string | null;
  uaePassEmail?: string | null;
  poBox: string;
  emirate: string;
  businessType: string | null;
  platform: string | null;
  vatRegNO: string | null;
  name: string | null;
  username: string | null;
  password: string | null;
  premiseId: string | null;
  email: string | null;
  propertyDetails: string | null;
  propertyUsage: string | null;
  mobileNumber: string | null;
  dateOfBirth: string | null;
  gender: Obj | null;
  nationality: Obj | null;
  CurrentLanguage: Obj | null;
  alternateEmail?: string | null;
  favouriteServiceDeliveryChannel: Obj | null;
  favouritePaymentChannel: Obj | null;
  morning: boolean | null;
  afternoon: boolean | null;
  evening: boolean | null;
  tenancyContract?: string | null;
};

class MoveInOut {
  sewerageNumbers: Obj[] = [];
  email: any = "";
  moveOutInfo: Obj = {};
  moveOutDues: Obj = {};
  userValidatedDetails: Obj = {};
  paymentDetails: Obj = {};
  paymentResponseMoveIn: Obj = {};
  paymentResponseMoveOut: Obj = {};
  moveInRegistrationResponse: Obj = {};
  moveOutResponse: Obj = {};
  moveInResponse: Obj = {};
  moveOutEligibility: Obj = {};
  moveoutDisputeDetails: Obj = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true, deep: true }); //persist

    makePersistable(this, {
      name: "movein",
      properties: ["sewerageNumbers", "userValidatedDetails", "moveInResponse"],
      storage: window.localStorage,
    });
    makePersistable(this, {
      name: "userValidatedDetails",
      properties: ["userValidatedDetails"],
      storage: window.localStorage,
    });
  }
   removeMoveOutDues=()=>{
    this.moveOutDues={}
    
  }
  clearCache=()=>{
    this.moveInRegistrationResponse={}
    this.moveInResponse={}
    this.userValidatedDetails={}
  }
  getMoveInDue = ErrorWrapper(
    async ({
      premiseId,
      personID,
    }: {
      premiseId: string;
      personID: string;
    }) => {
      const data = {
        premiseId,
        personID,
        platform: "Web",
      };
      console.log('h_',data);
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.GET_MOVEIN_DUE,
        type: "GET",
        data,
      });

      runInAction(() => {
        this.paymentDetails = res.result;
      });
    }
  );

  //emiratesId==> Individual | tradeLicense==>business DUHHHH

  // getMoveInDetails = ErrorWrapper(
  //   async ({
  //     id,
  //     type,
  //     premiseId,
  //   }: {
  //     id: string;
  //     type: string;
  //     premiseId: string;
  //   }) => {

  //     const data = {
  //       id,
  //       type,
  //       premiseId,
  //     };

  //     const res = await callRemoteMethod({
  //       endpoint: CONSTANTS.URL.REGISTRATION_MOVEIN_DETAILS,
  //       type: "GET",
  //       data,
  //     });

  //     // runInAction(() => {
  //     //   this.userValidatedDetails = res?.result.user ? res.result.user : {};
  //     // });

  //     runInAction(() => {

  //       if (res?.result?.user !== null && res?.result?.hasUserDetails) {
  //         this.userValidatedDetails = res?.result?.user;
  //       } else {
  //         this.userValidatedDetails = {};

  //         // this.userValidatedDetails = {
  //         //   name: "Mohamad, Ahmad, Chouki, Habbal",
  //         //   mobileNumber: "05X-XXX-XXXX",
  //         //   email: "demo@gmail.com",
  //         //   personId: "8291682336",
  //         //   CurrentLanguage: {
  //         //     key: "ARA",
  //         //     value: "Arabic",
  //         //   },
  //         //   alternateEmail: "",
  //         //   dob: null,
  //         //   favouriteServiceDeliveryChannel: null,
  //         //   favouritePaymentChannel: null,
  //         //   gender: null,
  //         //   morning: true,
  //         //   afternoon: true,
  //         //   evening: true,
  //         //   contractDate: null,
  //         //   tenancyContractExpiryDate: "2029-07-03T09:21:22.860Z",
  //         //   dateOfBirth: "2019-07-03T09:21:22.860Z",
  //         //   nationality: {
  //         //     key: "XXX",
  //         //     value: "XXXXXXX",
  //         //   },
  //         //   vatRegistrationNo: "",
  //         // };
  //       }
  //     });

  //   }
  // );

  getMoveInDetails = async ({ id, type, premiseId }: any) => {
    const data = {
      id,
      type,
      premiseId,
    };
    const config = {
      params: data, // Pass the data object as the 'params' property of the config
    };

    try {
      const res:any = await axios.get(
        CONSTANTS.URL.REGISTRATION_MOVEIN_DETAILS,
        config
      );

      runInAction(() => {
        if (
          res?.data?.result?.user !== null &&
          res?.data?.result?.hasUserDetails
        ) {
          this.userValidatedDetails = res?.data?.result?.user;
        } else {
          this.userValidatedDetails = {};
        }
      });
      return res?.data?.result?.gracePeriod; // Resolve the promise with the response
    } catch (error:any) {
      NotifyError(General?.codeLabels[error?.response?.data?.error[0]?.message]?.label || "An error occurred while fetching move-in details.");
      throw error; // Throw the error to be caught by the caller
    }
  };

  //** MOVE OUT

  getMoveOutProperties = ErrorWrapper(async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_MOVEOUT_PROPERTIES,
    });

    runInAction(() => {
      this.sewerageNumbers = res.result.accountNumbers;
    });
  });

  validateMoveOut = ErrorWrapper(async (accountId: string) => {
    const data = {
      accountId,
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_MOVEOUT,
      type: "POST",
      data,
    });

    runInAction(() => {
      this.moveOutInfo = res.result;
    });
  });
  checkMoveOutApprovalEligibility = ErrorWrapper(async (input: { accountId: string; premiseId: string }) => {
    const data = {
      accountId: input.accountId,
      premiseId: input.premiseId
    };
    console.log("data", data);
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CHECK_MOVE_OUT_APPROVAL_ELIGIBILITY,
      type: "GET",
      data,
    });
    runInAction(() => {
      this.moveOutEligibility = res.result;
    });
    return res;
    
  });
  uploadMoveOutDocuments = ErrorWrapper(async (data:any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UPLOAD_MOVEOUT_DOCUMENTS,
      type: "POST",
      data,
    });

    
    return res?.result;
    
  })

  //, isNOCSelected: boolean, isNoc: boolean, platform:string
  getMoveOutDue = async() => {
    const data = {
      accountId: this.moveOutInfo.accountId,
      // isNOCSelected,
      // isNoc,
      platform : "Web",
    };

  const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_MOVEOUT_DUES,
      type: "POST",
      data,
    });

    runInAction(() => {
      this.moveOutDues = res.result;
    });
  
  };

  moveOut = ErrorWrapper(
    async ({
      estimatedBillId,
      accountId,
      isNOCSelected,
      premiseId,
      serviceTerminationDate,
      customerAddress,
      transactionId
    }: {
      estimatedBillId: string;
      accountId: string;
      isNOCSelected: boolean;
      premiseId: string;
      serviceTerminationDate: string;
      customerAddress: Obj;
      transactionId: string
    }) => {
      const data = {
        platform: "web",
        estimatedBillId,
        accountId,
        isNOCSelected,
        premiseId,
        serviceTerminationDate,
        customerAddress,
        transactionId
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.MOVEOUT,
        type: "POST",
        data,
      });

      runInAction(() => {
        this.moveOutResponse = res.result;
      });
      return res?.result;
    }
  );

  moveInPayment = ErrorWrapper(
    async ({
      token,
      transactionId,
      amount,
      accounts,
      personId,
      paymentRequestType ,
      cvv,
      type,
      email,
    }: {
      token: string;
      email: string;
      transactionId: string;
      amount: Number;
      accounts: Obj[];
      personId: string;
      paymentRequestType: Number;
      cvv: string;
      type: string;
    }) => {
      const data = {
        platform: "web",
        token: token,
        transactionId: transactionId,
        amount: amount,
        accounts: accounts,
        personId: personId,
        paymentRequestType: paymentRequestType, //1 = not from saved cards
        cvv: cvv,
        type: type,
        email:this?.email,
      };
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.MOVEIN_PAYMEMT,
        type: "POST",
        data,
      });

      runInAction(() => {
        this.paymentResponseMoveIn = res.result;
      });
      return res;
    }
  );

  NImoveInPayment = async (payload: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.NI_MOVEIN_PAYMENT,
      type: "POST",
      data: payload,
    });
    runInAction(() => {
      this.paymentResponseMoveIn = res.result;
    });
    return res;
  };
  TabbymoveInPayment = async (payload: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TABBY_MOVEIN_PAYMENT,
      type: "POST",
      data: payload,
    });
    runInAction(() => {
      this.paymentResponseMoveIn = res.result;
    });
    return res;
  };
  TamaramoveInPayment = async (payload: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TAMARA_MOVEIN_PAYMENT,
      type: "POST",
      data: payload,
    });
    runInAction(() => {
      this.paymentResponseMoveIn = res.result;
    });
    return res;
  };

  NImoveOutPayment = async (payload:any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.NI_MOVEOUT_PAYMENT,
      type: "POST",
      data: payload,
    });
    runInAction(() => {
      this.paymentResponseMoveOut = res.result;
    });
    return res;
  };
  TabbymoveOutPayment = async (payload:any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TABBY_MOVEOUT_PAYMENT,
      type: "POST",
      data: payload,
    });
    runInAction(() => {
      this.paymentResponseMoveOut = res.result;
    });
    return res;
  };

   TamaramoveOutPayment = async (payload:any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TAMARA_MOVEOUT_PAYMENT,
      type: "POST",
      data: payload,
    });
    runInAction(() => {
      this.paymentResponseMoveOut = res.result;
    });
    return res;
  };
  

  setEmail=(email:string)=>{
    runInAction(() => {
      this.email = email;
    });
  }
  payment3Ds = ErrorWrapper(async ({ postData }: any) => {
    const data = {
      sessionId: postData,
      platform: "aspcl",
    };
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.MOVEIN_PAYMEMT_UPDATE,
      type: "POST",
      data,
    });
    return res;
  });

  moveOutPayment = ErrorWrapper(
    async ({
      sewerageId,
      serviceTerminationDate,
      isNOCSelected,
      amount,
      token,
      accountId,
      estimatedBillId,
      transactionId,
      paymentRequestType,
      cvv,
      type,
      customerAddress,
    }: MoveOutData) => {
      

      const data = {
        platform: "web",
        token,
        transactionId,
        amount,
        paymentRequestType, //1 = not from saved cards
        cvv,
        type,
        sewerageId,
        serviceTerminationDate,
        isNOCSelected,
        accountId,
        estimatedBillId,
        customerAddress,
        // email:this?.email?this?.email:User?.profile?.email,
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.MOVEOUT_PAYMEMT,
        type: "POST",
        data,
      });

      runInAction(() => {
        this.paymentResponseMoveOut = res.result;
      });
    }
  );

  // registerMoveIn = ErrorWrapper(
  //   async ({
  //     platform,
  //     type,
  //     businessType,
  //     id,
  //     accountNumber,
  //     premiseId,
  //     personId,
  //     username,
  //     password,
  //     name,
  //     mobileNumber,
  //     isUAEPASSEnabled,
  //     vatRegNO,
  //     registraionType,
  //     email,
  //     alternateEmail,
  //     gender,
  //     nationality,
  //     language,
  //     favouriteServiceDeliveryChannel,
  //     favouritePaymentChannel,
  //     dateOfBirth,
  //     morning,
  //     afternoon,
  //     evening,
  //     poBox,
  //     emirate,
  //     uuid,
  //     uaePassEmail,
  //     premiseEmail,
  //     premiseMobile,
  //     uaePassMobileNumber,
  //     emiratesId,
  //     tenancyContract,
  //     existingMobileNumber,
  //     registrationType,
  //     deviceVersion,
  //     location,
  //     browser,
  //     transactionId,
  //     enableConsent,
  //     modeOfConsent,
  //   }: any) => {
  //     const data = JSON.stringify({
  //       platform,
  //       type,
  //       id,
  //       uuid,
  //       uaePassEmail,
  //       uaePassMobileNumber,
  //       premiseEmail,
  //       premiseMobile,
  //       personId,
  //       vatRegNO,
  //       isUAEPASSEnabled,
  //       poBox,
  //       emirate,
  //       emiratesId,
  //       name,
  //       username,
  //       password,
  //       premiseId,
  //       email,
  //       mobileNumber,
  //       dateOfBirth,
  //       gender,
  //       nationality,
  //       language,
  //       favouriteServiceDeliveryChannel,
  //       favouritePaymentChannel,
  //       morning,
  //       afternoon,
  //       evening,
  //       tenancyContract,
  //       businessType,
  //       accountNumber,
  //       registraionType,
  //       existingMobileNumber,
  //       alternateEmail,
  //       registrationType,
  //       deviceVersion,
  //       location,
  //       browser,
  //       transactionId,
  //       enableConsent,
  //       modeOfConsent,
  //     //   modeForMoveIn:"",
  //     //   lifeSupport:"",
  //     //   customerClass:"",
  //     //   billRouteType:"",
  //     //   address1:General?.premise?.premiseDetails,
  //     //  tenancyContractNumber:"",

  //     });
  //     const payload = {
  //       data: data,
  //     }
  //     const res = await callRemoteMethod({
  //       endpoint: CONSTANTS.URL.REGISTER_MOVEIN,
  //       type: "POST",
  //       data,
  //     });

  //     runInAction(() => {
  //       this.moveInRegistrationResponse = res.result;
  //     });
      
  //   }
  // );
   registerMoveIn = ErrorWrapper(
    async (data: any) => {
      // const data = JSON.stringify({
      //   platform,
      //   type,
      //   id,
      //   uuid,
      //   uaePassEmail,
      //   uaePassMobileNumber,
      //   premiseEmail,
      //   premiseMobile,
      //   personId,
      //   vatRegNO,
      //   isUAEPASSEnabled,
      //   poBox,
      //   emirate,
      //   emiratesId,
      //   name,
      //   username,
      //   password,
      //   premiseId,
      //   email,
      //   mobileNumber,
      //   dateOfBirth,
      //   gender,
      //   nationality,
      //   language,
      //   favouriteServiceDeliveryChannel,
      //   favouritePaymentChannel,
      //   morning,
      //   afternoon,
      //   evening,
      //   tenancyContract,
      //   businessType,
      //   accountNumber,
      //   registraionType,
      //   existingMobileNumber,
      //   alternateEmail,
      //   registrationType,
      //   deviceVersion,
      //   location,
      //   browser,
      //   transactionId,
      //   enableConsent,
      //   modeOfConsent,
      // //   modeForMoveIn:"",
      // //   lifeSupport:"",
      // //   customerClass:"",
      // //   billRouteType:"",
      // //   address1:General?.premise?.premiseDetails,
      // //  tenancyContractNumber:"",

      // });
      // const payload = {
      //   data: data,
      // }
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.REGISTER_MOVEIN,
        type: "POST",
        data,
      });

      runInAction(() => {
        this.moveInRegistrationResponse = res.result;
      });
      
    }
  );
  // const res = await callRemoteMethod({
  //   endpoint: CONSTANTS.URL.MOVEIN,
  //   type: "POST",
  //   data,
  // });
  // runInAction(() => {
  //   this.moveInResponse = res.result;
  //   this.moveInRegistrationResponse = res.result;
  // });
  // return res;
  moveIn = ErrorWrapper(async (data: any) => {
    // const data = {
    //   premiseId,
    //   vatNo: null,
    //   platform: "web",
    // };
   
 // Assuming 'token' is obtained from some source
    let { info } = await User;
    return new Promise((resolve, reject) => {
      axios
        .post(CONSTANTS.URL.MOVEIN, 
          data, {
          headers: {
            Authorization: `Bearer ${info?.token}`, // Adding the info?.token to the request headers
            CurrentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US"
          }
        })
        .then((response) => {
          resolve(response);
          console.log(response);
          runInAction(() => {
            this.moveInResponse = response.data.result;
            this.moveInRegistrationResponse = response.data.result;
          });
        })
        .catch((error) => {
          const originalString = error?.response?.data?.error[0]?.message;
          const modifiedString = originalString.replace(/<br>/g, '');
          NotifyError(modifiedString);
          reject(error);
        });
    });
    
    
  });

  validateUserName = ErrorWrapper(async (userName: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_USERNAME(userName),
      type: "GET",
    });
    return res;
  });

  checkMoveInOrderExist = ErrorWrapper(async (data: any) => {
    const { premiseId } = data;
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CHECK_MOVE_IN_ORDER_EXIST(premiseId),
      type: "GET",
    });
    return res;
  });

    /**
     * Validates the strength and format of the provided password.
     * @param data - The password validation data payload.
     * @returns A response indicating whether the password is valid.
     */
    validatePassword = ErrorWrapper(async (data: IValidatePassword) => {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.IS_VALID_PASSWORD,
        type: "POST",
        data,
      });
  
      return res;
    });
    validatePasswordForRegistration = ErrorWrapper(async (data: IValidatePasswordForRegistration) => {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.VALIDATE_PASSWORD_REGISTRATION,
        type: "POST",
        data,
      });
  
      return res;
    });

  getMoveOutDisputeDetails = ErrorWrapper(async ({ parcelNumber, unitNumber }: { parcelNumber: string, unitNumber: string }) => {
    const data = {
      parcelNumber,
      unitNumber
    };
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.MOVEOUT_DISPUTE(Number(parcelNumber), Number(unitNumber)),
    });
    return res.result;
  });
  checkDisputeExist = ErrorWrapper(async (data:any) => {
    // console.log("personID", personId);
    const { personId, premiseId } = data;
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_DISPUTE(personId,premiseId),
    });
    
    return res;
  })
  applyMoveOutDispute = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.APPLY_MOVEOUT_DISPUTE,
      type: "POST",
      data,
    });
    runInAction(() => {
    this.moveoutDisputeDetails.referenceId = res.result;
    });
    return res.result;
  });
  getDisputeDues = ErrorWrapper(async (caseId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_DISPUTE_DUES(caseId),
    });
    return res.result;
  });
  rentalDisputePayment = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.RENTAL_DISPUTE_PAYMENT,
      type: "POST",
      data,
    });
    return res.result;
  })

  NIrentalDisputePayment = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.NI_RENTAL_DISPUTE_PAYMENT,
      type: "POST",
      data,
    });
    return res;
  })
    TabbyrentalDisputePayment = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TABBY_RENTAL_DISPUTE_PAYMENT,
      type: "POST",
      data,
    });
    return res;
  })

  TamararentalDisputePayment = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TAMARA_RENTAL_DISPUTE_PAYMENT,
      type: "POST",
      data,
    });
    return res;
  })

   makeTabbyEligibilityCheck =ErrorWrapper(
    async (incomingDate: any) => {
      const data = {
        ...incomingDate,
        platform: "Web",
      };
  
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.TABBY_ELIGIBILITY,
        type: "POST",
        data,
      });
      return res;
    }
  );
    
}

const moveInOutStore = new MoveInOut();
export default moveInOutStore;
